import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { AppErrorMessagesComponent } from 'src/app/base/error-messages/app-error-messages.component';

export type VerifyRecoveryCodeFormType = {
  recoveryCode: FormControl<string>
}

@Component({
    selector: 'app-step-verify-recovery-code',
    templateUrl: './step-verify-recovery-code.component.html',
    styleUrls: ['./step-verify-recovery-code.component.scss'],
    imports: [AppErrorMessagesComponent, TranslateModule, ReactiveFormsModule]
})
export class StepVerifyRecoveryCodeComponent implements OnInit {

  @Input() loading: boolean;
  @Output() next = new EventEmitter<FormGroup<VerifyRecoveryCodeFormType>>();
  public validateForm: FormGroup<VerifyRecoveryCodeFormType>;
  constructor(private fb: FormBuilder) { }

  ngOnInit() {
    this.initializeForm();
  }

  public validateRecoveryCode(): void {
    if (this.validateForm.invalid || this.loading) {
      return;
    }
    this.next.emit(this.validateForm);
  }

  private initializeForm(): void {
    this.validateForm = this.fb.group<VerifyRecoveryCodeFormType>({
      recoveryCode: this.fb.control<string>(null, Validators.required)
    });
  }

}
